import React, { useState, useEffect } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { Link, useLocation } from 'react-router-dom';
import { SidebarData } from '../../core/json/siderbar_data';
import HorizontalSidebar from './horizontalSidebar';
import CollapsedSidebar from './collapsedSidebar';

const Sidebar = () => {
  const Location = useLocation();
  const [subOpen, setSubopen] = useState('');
  const [subsidebar, setSubsidebar] = useState('');
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    // Function to update menu data
    const updateMenuData = () => {
      const currentMenuData = SidebarData(); // Call the function to get current menu data
      //console.log('Updating menu data:', currentMenuData); // Debug log
      setMenuData(currentMenuData);
    };

    // Initial load
    updateMenuData();

    // Set up interval to check for role changes
    const interval = setInterval(updateMenuData, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  const toggleSidebar = title => {
    if (title === subOpen) {
      setSubopen('');
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = subitem => {
    if (subitem === subsidebar) {
      setSubsidebar('');
    } else {
      setSubsidebar(subitem);
    }
  };

  // Debug log
  //console.log('Current menuData:', menuData);

  if (!menuData || !menuData.length) {
    console.log('No menu data available'); // Debug log
    return null;
  }

  return (
    <div className="sidebar" id="sidebar">
      <Scrollbars>
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              {menuData.map((mainLabel, index) => (
                <li className="submenu-open" key={index}>
                  <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                  <ul>
                    {mainLabel?.submenuItems?.map((title, i) => (
                      <React.Fragment key={i}>
                        <li
                          className={`submenu ${
                            !title?.submenu && Location.pathname === title?.link
                              ? 'custom-active-hassubroute-false'
                              : ''
                          }`}
                        >
                          {title?.external ? (
                            <a target='_blank' rel='noopener noreferrer' href={title?.link}>
                              {title?.icon}
                              <span className="custom-active-span">{title?.label}</span>
                            </a>
                          ) : (
                            <Link
                              to={title?.link}
                              onClick={() => toggleSidebar(title?.label)}
                              className={`${subOpen === title?.label ? 'subdrop' : ''} ${
                                Location.pathname === title?.link ? 'active' : ''
                              }`}
                            >
                              {title?.icon}
                              <span className="custom-active-span">{title?.label}</span>
                              {title?.submenu && <span className="menu-arrow" />}
                            </Link>
                          )}
                          {title?.submenuItems && (
                            <ul
                              style={{
                                display: subOpen === title?.label ? 'block' : 'none',
                              }}
                            >
                              {title?.submenuItems?.map((item, titleIndex) => (
                                <li className="submenu submenu-two" key={titleIndex}>
                                  <Link
                                    to={item?.link}
                                    className={`${
                                      Location.pathname === item?.link ? 'active' : ''
                                    } ${subsidebar === item?.label ? 'subdrop' : ''}`}
                                    onClick={() => toggleSubsidebar(item?.label)}
                                  >
                                    {item?.label}
                                    {item?.submenu && (
                                      <span className="menu-arrow inside-submenu" />
                                    )}
                                  </Link>
                                  {item?.submenuItems && (
                                    <ul
                                      style={{
                                        display: subsidebar === item?.label ? 'block' : 'none',
                                      }}
                                    >
                                      {item?.submenuItems?.map((items, subIndex) => (
                                        <li key={subIndex}>
                                          <Link
                                            to={items?.link}
                                            className={`${
                                              subsidebar === items?.label
                                                ? 'submenu-two subdrop'
                                                : 'submenu-two'
                                            } ${
                                              Location.pathname === items?.link ? 'active' : ''
                                            }`}
                                          >
                                            {items?.label}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      </React.Fragment>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Scrollbars>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
